import ServiceCRUD from '../../../../services/ServiceGasOrder';

class OportunityListRead extends ServiceCRUD {
  constructor() {
    super(`/api/ler-oportunidades`);
  }
}

export default new OportunityListRead();
